<div class="multiselect-box">
  <div class="control">
    <label
      class="label content is-small has-text-weight-normal"
      (click)="showList = true"
      >{{ label }}
    </label>

    <!-- Fake select -->
    <div
      class="select select--simulate"
      [ngClass]="{
        'is-focus': showList && options?.length,
        'is-link': activeOptions?.length > 0
      }"
      (click)="showList = !showList"
    >
      <ng-container [ngPlural]="activeOptions.length">
        <ng-template ngPluralCase="=0">All</ng-template>
        <ng-template ngPluralCase="=1">1 item selected</ng-template>
        <ng-template ngPluralCase="other"
          >{{ activeOptions.length }} items selected
        </ng-template>
      </ng-container>
    </div>

    <!-- Dropdown checkbox list -->
    <div class="box" *ngIf="showList && options?.length">
      <!-- Mass selection -->
      <p class="pb-2 px-4 is-size-7">
        <a
          class="small-meta mass-selection-button has-text-grey-dark is-underlined is-inline-block is-fullwidth"
          *ngIf="activeOptions.length < options.length"
          (click)="selectAll()"
          >Select all</a
        >
        <a
          class="small-meta mass-selection-button has-text-grey-dark is-underlined is-inline-block is-fullwidth"
          *ngIf="activeOptions.length === options.length"
          (click)="selectNone()"
          >Select none</a
        >
      </p>
      <div
        class="control px-4 py-1 is-fullwidth"
        *ngFor="let option of options"
      >
        <label
          class="checkbox is-small"
          [ngClass]="{
            'is-checked': activeOptions.includes(option)
          }"
          (click)="toggleSelected(option)"
        >
          {{ option }}
          <span class="checkmark"></span>
        </label>
      </div>
    </div>
  </div>
</div>
